module.exports = __webpack_public_path__ + "static/media/card_answer.5a5dd38c.png";